<!--
  Copyright (C) 2022 - Jeci SARL - https://jeci.fr

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU Affero General Public License as
  published by the Free Software Foundation, either version 3 of the
  License, or (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Affero General Public License for more details.

  You should have received a copy of the GNU Affero General Public License
  along with this program.  If not, see https://www.gnu.org/licenses/agpl-3.0.html.
-->
<template>
  <div class="config-upload">
    <p class="config-upload-description">
      {{ $t("config.raw.uploadDescription") }}
    </p>
    <PrimeFileUpload
      mode="basic"
      name="configfile[]"
      accept=".json"
      :maxFileSize="1000000"
      customUpload
      @uploader="handleFileUpload"
      :chooseLabel="$t('config.raw.uploadButton')"
      auto
      :loading="loading"
      severity="danger"
      class="config-upload-button"
    />
    <small class="config-upload-warning">{{
      $t("config.raw.uploadWarning")
    }}</small>
  </div>
</template>

<script>
import FileUpload from "primevue/fileupload";

export default {
  name: "ConfigUpload",
  components: {
    PrimeFileUpload: FileUpload,
  },
  props: {
    loading: { type: Boolean, default: false },
  },
  emits: ["upload-config"],
  methods: {
    handleFileUpload(event) {
      const file = event.files[0];
      if (!file) {
        return;
      }

      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          const parsedJson = JSON.parse(e.target.result);
          this.$emit("upload-config", parsedJson);
        } catch (error) {
          this.$toast.add({
            severity: "error",
            summary: "Fichier Invalide",
            detail: this.$t("config.errors.invalidJsonFile"),
            life: 4000,
          });
        }
      };
      reader.onerror = (e) => {
        console.error("handle file upload error", e);
      };
      reader.readAsText(file);
    },
  },
};
</script>

<style scoped>
.config-upload {
  padding: 1rem;
}

.config-upload-description {
  margin: 0 0 1rem 0;
  color: var(--p-text-muted-color);
}

.config-upload-button {
  width: 100%;
}

.config-upload-warning {
  display: block;
  margin-top: 0.5rem;
}
</style>
